import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { adminApi } from "@/lib/api";
import { ShieldCheck } from "lucide-react";
import Logo from "@/components/Logo";
import toast from "react-hot-toast";

export default function AdminLogin() {
    const nav = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const r = await adminApi.post("/admin/login", { email, password });
            localStorage.setItem("rk_admin_token", r.data.token);
            localStorage.setItem("rk_admin", JSON.stringify(r.data.admin));
            toast.success("Welcome, Admin.");
            nav("/admin");
        } catch (e) {
            toast.error(e.response?.data?.detail || "Login failed");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-rk-bg flex items-center justify-center px-4 py-10 relative overflow-hidden">
            {/* Decorative */}
            <div className="absolute inset-0 bg-rk-navy opacity-5" style={{backgroundImage: "radial-gradient(circle at 20% 30%, #C9A959 0%, transparent 40%), radial-gradient(circle at 80% 80%, #0B1437 0%, transparent 40%)"}} />
            <form
                onSubmit={submit}
                data-testid="admin-login-form"
                className="relative w-full max-w-md bg-white border-t-4 border-rk-gold p-10 md:p-12 shadow-2xl"
            >
                <Logo />
                <div className="rk-divider-gold w-16 mt-6 mb-6" />
                <div className="flex items-center gap-2 text-[10px] uppercase tracking-[0.28em] text-rk-gold-deep mb-3">
                    <ShieldCheck className="w-3 h-3" /> Admin Portal
                </div>
                <h1 className="font-serif text-4xl font-light text-rk-navy">Sign in</h1>
                <p className="text-sm text-rk-muted mt-2 mb-8">Manage catalog, orders, users & analytics.</p>

                <label className="text-[10px] uppercase tracking-[0.28em] text-rk-muted">Email</label>
                <input
                    data-testid="admin-email-input"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    className="mt-2 mb-5 w-full px-4 py-4 border border-rk-navy/20 text-sm outline-none focus:border-rk-gold focus:ring-1 focus:ring-rk-gold text-rk-navy"
                />
                <label className="text-[10px] uppercase tracking-[0.28em] text-rk-muted">Password</label>
                <input
                    data-testid="admin-password-input"
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    className="mt-2 mb-8 w-full px-4 py-4 border border-rk-navy/20 text-sm outline-none focus:border-rk-gold focus:ring-1 focus:ring-rk-gold text-rk-navy"
                />
                <button
                    data-testid="admin-login-submit"
                    disabled={loading}
                    type="submit"
                    className="rk-btn-primary w-full"
                >
                    {loading ? "Signing in…" : "Sign in"}
                </button>
            </form>
        </div>
    );
}
